import React from 'react';
import {
    Wifi, Car, Tv, Trees, Dumbbell, Warehouse,
    Utensils, Lock, Users, Monitor, Droplets, Zap
} from 'lucide-react';
import { Badge } from '../ui/badge';

const iconMap = {
    'wifi': Wifi,
    'parking': Car,
    'tv': Tv,
    'garden': Trees,
    'gym': Dumbbell,
    'storage': Warehouse,
    'kitchen': Utensils,
    'security': Lock,
    'clubhouse': Users,
    'workspace': Monitor,
    'pool': Droplets,
    'power': Zap,
    // Default fallbacks handled in render
};

export default function AmenitiesGrid({ amenities = [] }) {
    if (!amenities || amenities.length === 0) return null;

    return (
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {amenities.map((amenity, idx) => {
                // Simple heuristic to match icons if exact key not found
                const lower = amenity.toLowerCase();
                let Icon = iconMap[lower] || Trees; // Default icon

                // Try partial matching if strict match fails
                if (!iconMap[lower]) {
                    if (lower.includes('power') || lower.includes('backup')) Icon = Zap;
                    else if (lower.includes('water')) Icon = Droplets;
                    else if (lower.includes('security') || lower.includes('gated')) Icon = Lock;
                    else if (lower.includes('club') || lower.includes('community')) Icon = Users;
                    else if (lower.includes('park')) Icon = Car;
                }

                return (
                    <div key={idx} className="flex items-center gap-3 p-3 rounded-lg bg-navy-50/50 hover:bg-navy-50 transition-colors border border-transparent hover:border-navy-100">
                        <div className="p-2 bg-white rounded-full shadow-sm text-navy-600">
                            <Icon className="w-5 h-5" />
                        </div>
                        <span className="font-medium text-navy-700 text-sm">{amenity}</span>
                    </div>
                );
            })}
        </div>
    );
}
